// Chat widget helper — migrated from Intercom to Crisp.
// Method names are kept (launchIntercom / showNewIntercomMessage / etc.) so the
// existing callers in App.vue, LandingPageFooter.vue and ParseData.js don't change.
export default {
  methods: {
    launchIntercom() {
      if (!window.$crisp) return;

      const isMobile = this.$vuetify.breakpoint.width <= 540;
      const updatePaymentRoute =
        this.$route.name === 'update-payment' ||
        this.$route.name === 'checkout-cancel' ||
        this.$route.name === 'checkout-success';

      if (updatePaymentRoute || isMobile) {
        window.$crisp.push(['do', 'chat:hide']);
        return;
      }
      window.$crisp.push(['do', 'chat:show']);

      const logged_in = this.$store.getters.getVal('sessionExists');
      const user_id = logged_in ? this.$store.getters.getVal('userInfo.user.id') : null;
      const email = logged_in ? this.$store.getters.getVal('userInfo.user.email') : null;

      // Identify logged-in, non-master users (email + user_id as session data)
      if (logged_in && !this.$store.getters.getVal('isMaster')) {
        if (email) window.$crisp.push(['set', 'user:email', [email]]);
        if (user_id) window.$crisp.push(['set', 'session:data', [[['user_id', String(user_id)]]]]);
      }
    },
    showNewIntercomMessage() {
      if (window.$crisp) window.$crisp.push(['do', 'chat:open']);
    },
    hideIntercom() {
      if (window.$crisp) window.$crisp.push(['do', 'chat:hide']);
    },
    shutdownIntercom() {
      if (window.$crisp) window.$crisp.push(['do', 'session:reset']);
    },
    onLogout() {
      this.shutdownIntercom();
      // Reset to anonymous visitor
      this.launchIntercom();
    },
    onAuth() {
      // Identify the user after auth (skip for master)
      if (!this.$store.getters.getVal('isMaster')) {
        this.launchIntercom();
      }
    },
  },
};
